/**
 * base64 <-> bytes, shared between the Worker and the browser.
 *
 * `atob`/`btoa` are Web Platform APIs, not Node built-ins, so this same code runs
 * unchanged in both — no bundler config, no isomorphic shim, just two functions
 * neither side needs to reimplement.
 */

export function bytesToBase64(bytes) {
  let bin = ''
  const chunk = 0x8000
  for (let i = 0; i < bytes.length; i += chunk) {
    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk))
  }
  return btoa(bin)
}

export const base64ToBytes = (b64) => Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))
